(function() {
  'use strict';

  // Cached offer items - initialized once on page load
  let offerItemsCache = null;

  // Get all offer items with tier data - runs once on initialization
  function initializeOfferItems() {
    const items = document.querySelectorAll('.subscription-section-type__unlock-offer-item[data-tier-level][data-tier-unlock-at]');
    offerItemsCache = Array.from(items).map(item => {
      const tierLevel = parseInt(item.getAttribute('data-tier-level'), 10);
      let tierUnlockAtValue = item.getAttribute('data-tier-unlock-at');
      let tierUnlockAt = 0;

      // Handle money object format (could be JSON string or number)
      try {
        const parsed = JSON.parse(tierUnlockAtValue);
        if (parsed && parsed.amount) {
          tierUnlockAt = parseFloat(parsed.amount);
        } else if (typeof parsed === 'number') {
          tierUnlockAt = parsed;
        } else {
          tierUnlockAt = parseFloat(tierUnlockAtValue) || 0;
        }
      } catch (e) {
        tierUnlockAt = parseFloat(tierUnlockAtValue) || 0;
      }

      // Ensure it's in dollars, not cents (if value seems too large, divide by 100)
      if (tierUnlockAt > 1000) {
        tierUnlockAt = tierUnlockAt / 100;
      }

      return {
        element: item,
        tierLevel: tierLevel,
        tierUnlockAt: tierUnlockAt,
        card: item.querySelector('.subscription-section-type__unlock-offer-item-card'),
        lockedBadge: item.querySelector('.subscription-section-type__unlock-offer-item-card-badge[data-badge="locked"]'),
        unlockedBadge: item.querySelector('.subscription-section-type__unlock-offer-item-card-badge[data-badge="unlocked"]'),
        addToUnlockBadge: item.querySelector('.subscription-section-type__unlock-offer-item-card-badge[data-badge="add-to-unlock"]'),
        dynamicValue: item.querySelector('[data-dynamic-value]'),
        image: item.querySelector('.subscription-section-type__unlock-offer-item-card-image img')
      };
    });
  }

  // Get cached offer items
  function getOfferItems() {
    return offerItemsCache || [];
  }

  // Get cart total
  async function getCartTotal() {
    try {
      const totalInDollars = window.upcartGetCart().total / 100;
      return totalInDollars;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return 0;
    }
  }

  // Get selected variant price
  function getSelectedVariantPrice() {
    // Find the checked variant option
    const checkedVariant = document.querySelector('input[name="variant-option"]:checked');
    if (!checkedVariant) return 0;

    // Get the label next to the input
    const label = checkedVariant.nextElementSibling;
    if (!label || !label.classList.contains('product-subscription-type__variant-label')) return 0;

    // Check if subscription or one-time is selected
    const isSubscription = document.querySelector('#subscriptionCheck')?.checked || false;

    // Get price from label - use data-price-plan for subscription (discounted), data-price for one-time
    const priceAttr = isSubscription
      ? label.getAttribute('data-price-plan') || label.getAttribute('data-price')
      : label.getAttribute('data-price');

    if (!priceAttr) return 0;

    // Extract price number from string like "$29.99" or "$1,299.99"
    const priceMatch = priceAttr.match(/[\d,]+\.?\d*/);
    if (!priceMatch) return 0;

    const price = parseFloat(priceMatch[0].replace(/,/g, ''));
    return price;
  }

  // Format money
  function formatMoney(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  // Update offer item state
  function updateOfferItem(item, cartTotal, totalWithVariant) {
    const isUnlockedWithCart = cartTotal >= item.tierUnlockAt;
    const isUnlockedWithVariant = totalWithVariant >= item.tierUnlockAt;

    // Hide all badges first
    if (item.lockedBadge) item.lockedBadge.classList.add('hide');
    if (item.unlockedBadge) item.unlockedBadge.classList.add('hide');
    if (item.addToUnlockBadge) item.addToUnlockBadge.classList.add('hide');

    if (isUnlockedWithCart) {
      // Already unlocked with what's in cart
      if (item.unlockedBadge) item.unlockedBadge.classList.remove('hide');
      if (item.card) {
        item.card.style.backgroundColor = 'rgba(3, 130, 129, 0.27)';
        item.card.setAttribute('data-unlocked', 'true');
      }
      if (item.image) {
        item.image.style.opacity = '1';
      }
    } else if (isUnlockedWithVariant) {
      // Would unlock if they add the selected variant
      if (item.addToUnlockBadge) item.addToUnlockBadge.classList.remove('hide');
      if (item.card) {
        item.card.style.backgroundColor = 'rgba(3, 130, 129, 0.27)';
        item.card.setAttribute('data-unlocked', 'true');
      }
      if (item.image) {
        item.image.style.opacity = '1';
      }
    } else {
      // Still locked, show how much more needed
      if (item.lockedBadge) item.lockedBadge.classList.remove('hide');
      if (item.card) {
        item.card.style.backgroundColor = 'rgba(234, 96, 57, 0.27)';
        item.card.removeAttribute('data-unlocked');
      }
      if (item.image) {
        item.image.style.opacity = '0.6';
      }
      const difference = item.tierUnlockAt - totalWithVariant;
      if (item.dynamicValue) {
        item.dynamicValue.textContent = formatMoney(difference);
      }
    }
  }

  // Main function to update all offers
  async function updateOffers() {
    if (!offerItemsCache || offerItemsCache.length === 0) return;

    const cartTotal = await getCartTotal();
    const variantPrice = getSelectedVariantPrice();
    const totalWithVariant = cartTotal + variantPrice;

    // Update each offer item with both cart total and total with variant
    offerItemsCache.forEach(item => {
      updateOfferItem(item, cartTotal, totalWithVariant);
    });
  }

  // Simple event delegation - one listener for everything
  document.addEventListener('change', function(e) {
    const target = e.target;
    if (target.name === 'variant-option' ||
        target.name === 'subscription-option' ||
        target.id === 'subscriptionCheck' ||
        target.id === 'onetimeCheck') {
      setTimeout(updateOffers, 100);
    }
  });

  document.addEventListener('click', function(e) {
    const target = e.target;
    if (target.closest('.product-subscription-type__variant') ||
        target.id === 'subscriptionCheck' ||
        target.id === 'onetimeCheck' ||
        target.getAttribute('for') === 'subscriptionCheck' ||
        target.getAttribute('for') === 'onetimeCheck') {
      setTimeout(updateOffers, 100);
    }
  });

  // Listen for cart updates
  document.addEventListener('cart:updated', updateOffers);
  document.addEventListener('cartUpdated', updateOffers);

  // Observe upCart shadow DOM for cart changes
  const observeUpCartShadow = () => {
    const upCart = document.querySelector('#upCart');
    if (!upCart) return;

    const checkShadow = () => {
      const shadow = upCart.shadowRoot;
      if (shadow) {
        // Observe changes inside the shadow
        const innerObserver = new MutationObserver(() => {
          innerObserver.disconnect();

          try {
            updateOffers();
          } catch(e) {
            console.error('Error updating offers:', e);
          }
          // Reconnect observer after a short delay
          setTimeout(() => {
            innerObserver.observe(shadow, { childList: true, subtree: true });
          }, 200);
        });
        innerObserver.observe(shadow, { childList: true, subtree: true });
      }
    };
    // Run once now
    checkShadow();
    // Watch if Shadow DOM gets re-attached later
    const rootObserver = new MutationObserver(checkShadow);
    rootObserver.observe(upCart, { childList: true, subtree: true });
  };

  // Initialize offer items cache and upCart observer
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeOfferItems();
      observeUpCartShadow();
      updateOffers();
    });
  } else {
    initializeOfferItems();
    observeUpCartShadow();
    setTimeout(updateOffers, 200);
  }

})();
